import React from 'react';
import PlaceIcon from '@mui/icons-material/Place';
import PhoneIcon from '@mui/icons-material/Phone';
import { NonceProvider } from 'react-select';
import QRCode from "../QRCode/qrcode.jpg";
import EmailIcon from '@mui/icons-material/Email';
const InvoicePrint = ({ onClose, labelData }) => {
    const containerStyle = {
        border: '1px solid #000',
        padding: '2px',
        width: '600px',
        height: '900px',
        margin: '5px auto',
    };

   

    const firstItem = labelData[0];
    const NumberToWords = (num) => {
        const belowTwenty = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
        const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
        const thousands = ["", "Thousand", "Lakh", "Crore"];

        const convert = (n) => {
            if (n === 0) return "";
            if (n < 20) return belowTwenty[n] + " ";
            if (n < 100) return tens[Math.floor(n / 10)] + " " + belowTwenty[n % 10] + " ";
            if (n < 1000) return belowTwenty[Math.floor(n / 100)] + " Hundred " + (n % 100 !== 0 ? convert(n % 100) : "");

            // Corrected loop for thousands
            for (let i = 0; i < thousands.length; i++) {
                const divisor = Math.pow(1000, i + 1); // 1000, 100000, 10000000...
                if (n < divisor) {
                    const currentDivisor = Math.pow(1000, i); // Get the current divisor (1000, 100000, etc.)
                    return convert(Math.floor(n / currentDivisor)) + " " + thousands[i] + " " + (n % currentDivisor !== 0 ? convert(n % currentDivisor) : "");
                }
            }
        };

        return convert(num).trim();
    };

    const AmountInWords = ({ amount }) => {
        const cleanedAmount = parseFloat(amount || 0).toFixed(2); // Ensure amount is valid
        const [rupees, decimal = "00"] = cleanedAmount.split('.');

        return (
            <div>
                <h5>Rupees {NumberToWords(parseInt(rupees))}Only</h5>
                {parseInt(decimal) > 0 && (
                    <p>{NumberToWords(parseInt(decimal))} Paise Only</p>
                )}
            </div>
        );
    };
    
    return (
        <div style={{ ...containerStyle, padding: '2px', marginLeft: '-0.92%' }}>
            {/* <style>{printStyles}</style> */}
            {firstItem && firstItem.CounterSalePrint && (
                <div>
                    <h4 style={{ textAlign: 'center', marginTop: '10px', color: 'blue', fontWeight: 'bold' }}>
                        {firstItem.CounterSalePrint.CompanyName}
                    </h4>

                    <div style={{ marginTop: '-5px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '-5px' }}>
                            <PlaceIcon style={{ color: 'green', width: '30px', height: '30px' }} />
                            <span style={{ marginLeft: '5px', color: 'black', fontWeight: 'normal', fontSize: '16px' }}>
                                {firstItem.CounterSalePrint.Address}, {firstItem.CounterSalePrint.Address1} , {firstItem.CounterSalePrint.Location} - {firstItem.CounterSalePrint.Pincode}
                            </span>
                        </div>
                       

                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                            <PhoneIcon style={{ color: 'blue', width: '30px', height: '30px' }} />
                            <span style={{ marginLeft: '5px', color: 'black', fontWeight: 'normal', fontSize: '16px' }}>
                                {firstItem.CounterSalePrint.CompanyContactNumber}
                            </span>
                            {/* </div>

                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}> */}
                            <EmailIcon style={{ color: 'blue', width: '30px', height: '30px', marginLeft: '5px' }} />
                            <span style={{ marginLeft: '5px', color: 'black', fontWeight: 'normal', fontSize: '15px' }}>
                                {firstItem.CounterSalePrint.Email}
                            </span>
                        </div>

                        <div style={{ marginLeft: '5px', marginTop: '10px' }}>
                            <h3 style={{ fontWeight: 'normal', fontSize: '15px' }}>
                                GST NO: {firstItem.CounterSalePrint.GSTNumber}
                            </h3>
                        </div>
                    </div>

                    <hr style={{ border: 'none', marginTop: '10px', borderTop: '1px solid black', margin: '20px -20px', width: 'calc(100% + 29px)' }} />

                    <div style={{ position: 'absolute', top: '30px', right: '20px' }}>
                        <img src={QRCode} alt="QR Code" style={{ width: '100px', height: '100px' }} />
                    </div>

                    <h2 style={{ textAlign: 'center', marginTop: '-10px', fontSize: '15px', fontWeight: 'bold' }}>
                        {firstItem.CounterSalePrint.IsReprint ? 'TAX INVOICE (Reprinted)' : 'TAX INVOICE'}
                    </h2>

                    <div style={{ marginBottom: '5px', fontSize: '14px', marginTop: '-10px' }}>
                        <strong style={{ fontSize: '14px', fontWeight: 'normal' }}>Customer <span style={{ marginLeft: '15px' }}> :</span> <span style={{ marginLeft: '5px', fontWeight: 'normal' }}>{firstItem.CounterSalePrint.Name}</span></strong>
                    </div>
                    <div style={{ marginBottom: '5px', fontSize: '14px' }}>
                        <strong style={{ fontSize: '14px', fontWeight: 'normal' }}>Phone No <span style={{ marginLeft: '15px' }}> :</span> <span style={{ marginLeft: '5px', fontWeight: 'normal' }}>{firstItem.CounterSalePrint.ContactNumber}</span></strong>
                    </div>
                    <div style={{ marginBottom: '5px', fontSize: '14px' }}>
                        <strong style={{ fontSize: '14px', fontWeight: 'normal' }}>Place <span style={{ marginLeft: '44px' }}> :</span> <span style={{ marginLeft: '5px', fontWeight: 'normal' }}>{firstItem.CounterSalePrint.CustomerAddess}</span></strong>
                    </div>
                    <div style={{ marginBottom: '5px', fontSize: '14px' }}>
                        <strong style={{ fontSize: '14px', fontWeight: 'normal' }}>GST No <span style={{ marginLeft: '28px' }}> :</span> <span style={{ marginLeft: '5px', fontWeight: 'normal' }}>{firstItem.CounterSalePrint.CustomerGSTNumber}</span></strong>
                    </div>
                    {firstItem.CounterSalePrint.TaxMethod === 1 && (
                        <div style={{ marginBottom: '5px', fontSize: '14px' }}>
                            <strong style={{ fontSize: '14px', fontWeight: 'normal' }}>Vehicle No <span style={{ marginLeft: '9px' }}> :</span> <span style={{ marginLeft: '5px', fontWeight: 'normal' }}>{firstItem.CounterSalePrint.Vehicleno}</span></strong>
                        </div>
                    )}
                    <div style={{ textAlign: 'right', marginBottom: '5px', fontSize: '14px', marginTop: '-10px' }}>
                        <strong style={{ fontSize: '14px', marginTop: '-10px', fontWeight: 'normal' }}>Invoice No:{firstItem.CounterSalePrint.prefix}{firstItem.CounterSalePrint.InvoiceNumber}/{firstItem.CounterSalePrint.FinYear}</strong>
                    </div>

                    <div style={{ textAlign: 'right', marginBottom: '5px', fontSize: '14px' }}>
                        <strong style={{ fontSize: '14px', marginTop: '-10px', fontWeight: 'normal' }}>Invoice Date: {new Date(firstItem.CounterSalePrint.InvoiceDate).toLocaleDateString('en-GB')}</strong>
                    </div>
                </div>

            )}

            {
                firstItem && firstItem.CounterSaleprintItems
                && (
                    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '-5px' }}>
                        
                        <thead>
                            <tr >
                                {firstItem.CounterSalePrint.TaxMethod === 1 && (
                                    <>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: '13px', width: '50px', fontWeight: 'normal' }}>Sl</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: '13px', fontWeight: 'normal' }}>HSN</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: '13px', width: '270px', fontWeight: 'normal' }}>Name</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: '13px', width: '50px', fontWeight: 'normal' }}>Rate </th>

                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: '13px', width: '30px', fontWeight: 'normal' }}>GST(%)</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: '13px', width: '50px', fontWeight: 'normal' }}>Qty</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: '13px', width: '70px', fontWeight: 'normal' }}>Taxable Amt</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: '13px', width: '70px', fontWeight: 'normal' }}>GST</th>

                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: '13px', width: '100px', fontWeight: 'normal' }}>Total Amt</th>
                                    </>
                                )}

                                {firstItem.CounterSalePrint.TaxMethod === 2 && (
                                    <>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: '13px', fontWeight: 'normal' }}>Sl</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: '13px', fontWeight: 'normal' }}>HSN</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: '13px', width: '270px', fontWeight: 'normal' }}>Name</th>
                                        {/* <th style={{ border: '1px solid #000', padding: '5px', fontWeight: '17px' }}>ItemCode</th> */}
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: '13px', width: '50px', fontWeight: 'normal' }}>Rate</th>
                                        {/* <th style={{ border: '1px solid #000', padding: '5px', fontWeight: '17px', width: '70px' }}>Discount</th> */}
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: '13px', width: '30px', fontWeight: 'normal' }}>GST(%)</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: '13px', width: '50px', fontWeight: 'normal' }}>Qty</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: '13px', width: '70px', fontWeight: 'normal' }}>Taxable Amt</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: '13px', width: '70px', fontWeight: 'normal' }}>GST</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: '13px', width: '100px', fontWeight: 'normal' }}>Total Amt</th>
                                    </>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {firstItem.CounterSaleprintItems.map((item, index) => (

                                <tr key={index}>
                                    {firstItem.CounterSalePrint.TaxMethod === 1 && (
                                        <>
                                            <td style={{ border: '1px solid #000', padding: '2px', color: 'black' }}>{index + 1}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', color: 'black' }}>{item.HSNCODE}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', color: 'black' }}>{item.ItemName}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right', color: 'black' }}>{item.Rate.toFixed(2)}</td>
                                            {/* <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'right', fontWeight: 'bold', color: 'black' }}>{(item.Discount)}</td> */}
                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'center', color: 'black' }}>{(item.GstRate)}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'center', color: 'black' }}>{item.Quantity}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right', color: 'black' }}>{item.NetAmount.toFixed(2)}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right', color: 'black' }}>{(item.CGSTAmount + item.SGSTAmount).toFixed(2)}</td>

                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right', color: 'black' }}>{(item.TotalAmount).toFixed(2)}</td>
                                        </>
                                    )}
                                    {firstItem.CounterSalePrint.TaxMethod === 2 && (
                                        <>
                                            <td style={{ border: '1px solid #000', padding: '2px', color: 'black' }}>{index + 1}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', color: 'black' }}>{item.HSNCODE}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', color: 'black' }}>{item.ItemName}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right', color: 'black' }}>{item.Rate.toFixed(2)}</td>
                                            {/* <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'right', fontWeight: 'bold', color: 'black' }}>{(item.Discount)}</td> */}
                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'center', color: 'black' }}>{(item.GstRate)}</td>
                                            {/* <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }}>{item.ItemCode}</td> */}
                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'center', color: 'black' }}>{item.Quantity}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right', color: 'black' }}>{item.NetAmount.toFixed(2)}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right', color: 'black' }}>{(item.CGSTAmount + item.SGSTAmount).toFixed(2)}</td>

                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right', color: 'black' }}>{(item.TotalAmount).toFixed(2)}</td>
                                        </>
                                    )}
                                </tr>
                            ))}
                        </tbody>

                        <tbody>
                            <tr>
                                {/* Bank Details */}
                                <td style={{ border: '1px solid #000', padding: '2px', color: 'black' }} colSpan="7">
                                    <table style={{ width: '100%' }}>

                                        <thead>
                                            <tr>
                                                <th style={{ border: 'none', padding: '2px', color: 'black', textAlign: 'left' ,fontWeight:'normal'}}>BANK   <span style={{ marginLeft: '37px' }}> :</span>  AXIS BANK</th>
                                            </tr>
                                            {/* </thead> */}

                                            <tr>
                                                <th style={{ border: 'none', padding: '2px', color: 'black', textAlign: 'left',fontWeight:'normal' }}>BRANCH  <span style={{ marginLeft: '15px' }}> :</span> <span style={{ marginLeft: '5px' }}>ANGAMALY </span></th>
                                            </tr>
                                            <tr>
                                                <th style={{ border: 'none', padding: '2', color: 'black', textAlign: 'left',fontWeight:'normal' }}>A/C NAME  <span style={{ marginLeft: '2px' }}> :</span> <span style={{ marginLeft: '5px' }}>PETERS RICE MILL</span></th>
                                            </tr>
                                            <tr>
                                                <th style={{ border: 'none', padding: '2px', color: 'black', textAlign: 'left',fontWeight:'normal' }}>A/C NO <span style={{ marginLeft: '25px' }}> :</span> <span style={{ marginLeft: '5px' }}>922030028095826</span></th>
                                            </tr>
                                            <tr>
                                                <th style={{ border: 'none', padding: '2px', color: 'black', textAlign: 'left' ,fontWeight:'normal'}}>IFSC   <span style={{ marginLeft: '45px' }}> :</span> <span style={{ marginLeft: '5px' }}> UTIB0001646</span></th>
                                            </tr>
                                            <tr>
                                                <th style={{ border: 'none', padding: '2px', color: 'black', textAlign: 'left' }}></th>
                                            </tr>
                                        </thead>
                                    </table>
                                </td>



                                {/* Empty Space */}
                                {/* <td style={{ border: '1px solid #000', width: '10px' }} colSpan="3"></td> */}

                                {/* Amount Details */}
                                <td style={{ border: '1px solid #000', padding: '2px', color: 'black' }} colSpan="1">
                                    <table style={{ width: '100%' }}>

                                        <tbody>
                                            <tr>
                                                <td style={{ padding: '2px', color: 'black', textAlign: 'left' }}>NetValue</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '2px', color: 'black', textAlign: 'left' }}>CGST</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '2px', color: 'black', textAlign: 'left' }}>SGST</td>
                                            </tr>
                                            {/* <tr>
                                                <td style={{ padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'left' }}>Discount</td>
                                            </tr> */}
                                            <tr>
                                                <td style={{ padding: '2px', color: 'black', textAlign: 'left' }}>RoundOff</td>
                                            </tr>

                                            <tr>
                                                <td style={{ padding: '2px', color: 'black', textAlign: 'left' }}>GrandTotal</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>

                                <td style={{ border: '1px solid #000', padding: '2px', color: 'black' }} colSpan="1">
                                    <table style={{ width: '100%' }}>

                                        <tbody>
                                            <tr>
                                                <td style={{ padding: '2px', color: 'black', textAlign: 'right' }}>{(firstItem.CounterSalePrint.NetAmount).toFixed(2)}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '2px', color: 'black', textAlign: 'right' }}>{(firstItem.CounterSalePrint.CGSTAmount).toFixed(2)}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '2px', color: 'black', textAlign: 'right' }}>{(firstItem.CounterSalePrint.SGSTAmount).toFixed(2)}</td>
                                            </tr>
                                            {/* <tr>
                                                <td style={{ padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'right' }}>{(firstItem.SaleOrderPrint.TotalDiscount).toFixed(2)}</td>
                                            </tr> */}
                                            <tr>
                                                <td style={{ padding: '2px', color: 'black', textAlign: 'right' }}>{(firstItem.CounterSalePrint.RoundOff).toFixed(2)}</td>
                                            </tr>

                                            <tr>
                                                <td style={{ padding: '2px', color: 'black', textAlign: 'right' }}>{(firstItem.CounterSalePrint.TotalAmount).toFixed(2)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>


                            </tr>

                        </tbody>

                    </table>

                )
            }



            {firstItem && firstItem.CounterSalePrint && (
                <div>
                    <h3 style={{ marginTop: '-10px', marginLeft: '10px', marginBottom: '2px' }}><AmountInWords amount={firstItem.CounterSalePrint.TotalAmount} /></h3>

                </div >
            )}
            <div>
                <h4 style={{ marginTop: '-10px', marginLeft: '10px', marginBottom: '2px' }}>
                    <u>Declaration</u>
                </h4>
                <p style={{ marginLeft: '10px', marginTop: '2px' }}>
                    We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct.
                </p>
            </div>

        </div >
    );
};

export default InvoicePrint;
